import { useFormik } from 'formik';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import * as Yup from 'yup';

export const useFormikCheckInSystem = (
  initEmail: string,
  makeRequest: any,
  tab: number
) => {
  const intl = useIntl();

  const validationSchema = useMemo(() => {
    return Yup.object().shape({
      email: Yup.string()
        .required(intl.formatMessage({ id: 'PROFILE.VALIDATION.REQUIRED_FIELD' }))
        .matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          intl.formatMessage({ id: 'AUTH.VALIDATION.INVALID_EMAIL' }) // Ошибка если email некорректен
        ),
    });
  }, [tab, intl]);

  const formik = useFormik({
    // enableReinitialize: true,
    validateOnChange: false,
    // validateOnBlur: false,
    initialValues: {
      email: initEmail
    },
    validationSchema,
    onSubmit: submitValues => {
      makeRequest({ ...submitValues }, tab);
    },
  });

  return formik;
};
